export function updateBookingSteps(previous, key, internal, value) {
    const next = { ...previous, [key]: { ...previous[key], internal, value } };
    const clear = (name) => { next[name] = { ...previous[name], internal: null, value: { title: null, subtitle: null } }; };
    if (key === 'LOCATION' && internal?.id !== previous.LOCATION.internal?.id) {
        ['GAME', 'TEAM', 'DATE'].forEach(clear);
    } else if (['GAME', 'TEAM'].includes(key) && internal !== previous[key].internal) {
        next.DATE = {
            ...previous.DATE,
            internal: previous.DATE.internal?.date ? { date: previous.DATE.internal.date, time: ' ', slot: null } : null,
            value: { title: previous.DATE.value.title, subtitle: null },
        };
        if (key === 'GAME' && (previous.TEAM.internal < internal.min_players || previous.TEAM.internal > internal.max_players)) clear('TEAM');
    }
    return next;
}

export function selectAlternativeSteps(previous, game, choice, locale, dateTitle) {
    return {
        ...previous,
        GAME: { ...previous.GAME, internal: game, value: { title: game.name.split(':')[0], subtitle: game.catch_phrase?.[locale] ?? null } },
        DATE: { ...previous.DATE, internal: choice, value: { title: dateTitle, subtitle: choice.time } },
    };
}

// A keyed component cancels on every context change; the guard also protects transports
// that resolve after abort (including a response already queued by the browser).
export function loadAlternatives(fetcher, url, params, onResult, onError) {
    const controller = new AbortController();
    let active = true;
    fetcher(url, { params, signal: controller.signal }).then(({ data }) => {
        if (active) onResult(data.alternatives);
    }).catch(() => {
        if (active) onError();
    });
    return () => { active = false; controller.abort(); };
}
